/* eslint-disable @next/next/no-img-element */
// components
import { MirandaSecondaryButton } from '@/components/Button/';
import { Container } from 'components/Grid';

// styles
import {
  SectionWrapper,
  Title,
  SectionPanel,
  Picture,
  Wrapper,
  MobileHide,
  Content,
} from './ImageCTA.styles';

export function ImageCTA() {
  return (
    <SectionWrapper>
      <Container>
        <SectionPanel>
          <Picture>
            <source
              srcSet={`/images/managed-transportation/mt-services@2x.png`}
              media="(min-width: 1920px)"
            />
            <source
              srcSet={`/images/managed-transportation/mt-services@2x.png`}
              media="(min-width: 1024px)"
            />
            <source
              srcSet={`/images/managed-transportation/mt-services@2x.png`}
              media="(min-width: 768px)"
            />
            <img
              src={`/images/managed-transportation/mt-services@2x.png`}
              alt="MTS plan: Plan, Execute, Settle, Measure, Improve"
              width="748"
              height="500"
            />
          </Picture>
          <Wrapper>
            <Title>
              Scale Smarter with 4PL Managed Transportation Services
            </Title>

            <Content>
              Cut freight costs by up to 20% and scale logistics without growing
              your headcount. Loadsmart’s 4PL Managed Transportation services
              flex with your needs—backed by expert teams and tech that adapt as
              you grow.
            </Content>

            <MirandaSecondaryButton as="a" href="/managed-transportation">
              Start Saving On Transportation
            </MirandaSecondaryButton>
          </Wrapper>
        </SectionPanel>
      </Container>
    </SectionWrapper>
  );
}
